import { ExternalLink } from "lucide-react";
import { fileUrl } from "../lib/api";

const Img = ({ src, id }) => <img data-testid={`${id}-image`} src={src} alt="output" className="out-img" />;

export const OutputView = ({ k, output, stream }) => {
  const id = `card-${k}`;
  if (k === "stream_chat" && stream !== null && !output) {
    return <pre data-testid={`${id}-stream`} className="out-text">{stream}<span className="caret" /></pre>;
  }
  if (!output) return null;
  return (
    <div className="space-y-3" data-testid={`${id}-output`}>
      {output.input_image && (
        <div className="flex items-center gap-3 text-xs text-[var(--muted)]">
          <img src={output.input_image} alt="sample" className="w-10 h-10 rounded border border-[var(--line)]" /> sample input
        </div>
      )}
      {output.image && <Img src={output.image} id={id} />}
      {output.audio && <audio data-testid={`${id}-audio`} controls src={output.audio} className="w-full" />}
      {output.text !== undefined && output.text !== null && (
        <pre data-testid={`${id}-text`} className="out-text">{output.text}</pre>
      )}
      {output.chunks !== undefined && <div className="meta">{output.chunks} stream chunks</div>}
      {output.downloaded_text && (
        <>
          <div className="meta">downloaded content</div>
          <pre data-testid={`${id}-downloaded`} className="out-text">{output.downloaded_text}</pre>
          <div className="meta">listed: {output.listed.map((o) => `${o.path.split("/").pop()} (${o.size}B)`).join(", ")}</div>
        </>
      )}
      {output.links?.map((l, i) => (
        <a key={l} data-testid={`${id}-link-${i}`} href={fileUrl(l)} target="_blank" rel="noreferrer" className="out-link">
          <ExternalLink size={12} /> {l.split("/").pop()}
        </a>
      ))}
      {output.link && (
        <a data-testid={`${id}-link`} href={output.link} target="_blank" rel="noreferrer" className="out-link">
          <ExternalLink size={12} /> provider URL
        </a>
      )}
      {output.message_id && (
        <div data-testid={`${id}-message-id`} className="meta">message id: <b className="text-[var(--fg)]">{output.message_id}</b> → {output.to}</div>
      )}
      {output.provider_response && <pre className="out-text text-xs">{JSON.stringify(output.provider_response, null, 2)}</pre>}
    </div>
  );
};
